export interface MilkAndDerivativesTypes {
  additionalItem1: string,
  additionalItem1Dose: number,
  additionalItem1Id: number,
  additionalItem1MeasurementUnit: string,
  additionalItem1MeasurementUnitId: string,
  additionalItem2: string,
  additionalItem2Dose: number,
  additionalItem2Id: number,
  additionalItem2MeasurementUnit: string,
  additionalItem2MeasurementUnitId: string,
  additionalItem3: string,
  additionalItem3Dose: number,
  additionalItem3Id: number,
  additionalItem3MeasurementUnit: string,
  additionalItem3MeasurementUnitId: string,
  additionalItem4: string,
  additionalItem4Dose: number,
  additionalItem4Id: number,
  additionalItem4MeasurementUnit: string,
  additionalItem4MeasurementUnitId: string,
  additionalPercentageItem1: string,
  additionalPercentageItem2: string,
  additionalPercentageItem3: string,
  additionalPercentageItem4: string,
  administration: string,
  administrationRoute1: string,
  administrationRouteType: string
  administrationType: string,
  applicationTime: number;
  dosageType: string;
  dose1: number,
  duration: string,
  durationType: string,
  endDate: moment.Moment,
  hours: string,
  id: number,
  infusionRate: number;
  interval: string,
  item: string,
  itemId: number,
  justification: string,
  measurementUnitCode1: string,
  measurementUnitDescription: string,
  observation: string,
  prescriberDt: string,
  prescriberName: string,
  startDate: moment.Moment,
  suctionDevice: string,
  suctionDeviceId: number
  temperature: string
  totalVolume: number
}

export enum AdministrationRouteType {
  ORAL = 'VO',
  IM_INJECTION = 'IM',
  INJECTION = 'IM',
  INTRAVENOUS = 'IV',
  EPIDURAL = 'Per',
  INFUSIONS = 'Sol',
  INJ1 = 'INJ1'
}